// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__NaBTa","popup":"Tooltip_popup__obATz","left":"Tooltip_left__J32PL","top":"Tooltip_top__Chaa5","bottom":"Tooltip_bottom__aIBjz"};